export default __webpack_public_path__ + "static/media/penelopecrews.fefef323.svg";